import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { encryptionTypeHostRecomm } from "@/api/php/home";
import { Toast } from "vant";
import { uitlsToLiveRoom, YMPush } from "@/uitls/uitls";
import { cheackQuery, ToBack } from "@/uitls/native";

import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'MoreRecomm',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const router = useRouter();
const route = useRoute();
let data = ref();
const livezb = require(`@/assets/${process.env.VUE_APP_NAME}/live-gif.gif`)
const livejj = require(`@/assets/${process.env.VUE_APP_NAME}/home_gif_mp4.gif`)
const liveqy = require(`@/assets/${process.env.VUE_APP_NAME}/live-ys-gif.gif`)
// const livetj = require(`@/assets/${process.env.VUE_APP_NAME}/home-match-rec.png`)
const livepb = require(`@/assets/${process.env.VUE_APP_NAME}/live_pb.gif`)

const title = ref('');
onMounted(() => {
  cheackQuery(route);
  YMPush('MAIN', 'MoreRecomm');
  if (
    route.query.type != "" &&
    route.query.type != null &&
    route.query.type != undefined
  ) {
    getdata();
  } else {
    Toast({
      message: "数据错误！",
      position: "bottom",
    });
    router.back();
  }
  // route.query.type == '1' ? t('home.index_title_zb') : t('home.bsjj')

  title.value = route.query.title as string;

});
const getdata = async () => {
  const res: any = await encryptionTypeHostRecomm({ type: route.query.type });
  if (res.code == 200) {
    data.value = res.data;
    // console.log(data.value);
  }
};
function formatNum(num) {
  if (num > 100000000) {
    return (num / 100000000).toFixed(0) + "亿";
  } else if (num > 10000) {
    if (num > 1000000) {
      return (num / 10000).toFixed(0) + "万";
    } else if (num > 100000) {
      return (num / 10000).toFixed(1) + "万";
    }
  }
  return num;
}

//判断有主播的，还是清源
const checkZb = (data) => {
  if (data.live_type == 1) {
    //有主播的
    return 0;
  } else if (
    data.live_type == 2
  ) {
    //清源
    return 1;
  } else if (data.live_type == 4) {
    return 4;
  } else {
    //mp4
    return 2
  }
}


const toLiveRoom = (data) => {
  uitlsToLiveRoom(data, router)
};

const __returned__ = { t, router, route, data, livezb, livejj, liveqy, livepb, title, getdata, formatNum, checkZb, toLiveRoom, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})